import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div `
  display: flex;
`;
export const IconSettings = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const svg = wrapperRef.current?.querySelector('svg');
            if (svg) {
                gsap.to(svg, {
                    keyframes: [
                        {
                            rotateZ: '-20deg',
                            duration: 0.1,
                        },
                        {
                            rotateZ: '90deg',
                            duration: 0.6,
                            ease: 'elastic.out(1, .7)',
                            clearProps: true,
                            onComplete: () => {
                                triggerDone();
                            },
                        },
                    ],
                });
            }
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Settings, null)));
};
//# sourceMappingURL=Settings.js.map